import { NormalizedCountry } from '@ravago/shared/page-data/models/contentful-mapped';
import { FacetResponse, FilterRange } from '@ravago/shared/page-data/models/elastic';

export interface FacetGroup {
   identifier: {
      key: string;
      label: string;
   };
   facets: FacetGroupContent[];
}

export interface FacetGroupContent {
   label: string;
   name: string;
   quantity: number;
   range?: FilterRange;
   nestedFacets?: FacetGroup[];
}

export interface FacetGroupStructureV2 {
   identifier: {
      key: string;
      label: string;
      collectionGroup?: boolean;
   };
   facets: FacetContentV2[];
}

export interface RangeDisplay {
   hasFillInBoxes?: boolean;
   step?: number;
   useSlider?: boolean;
}

export interface FacetContentV2 {
   label: string;
   key: string;
   count: number;
   hideCount?: boolean;
   keepFacetOrder?: boolean;
   range?: FilterRange;
   rangeDisplay?: RangeDisplay;
   nestedFacetGroups?: FacetGroupStructureV2[];
   unit?: 'SI' | 'US';
}

const getTranslatableKey = (identifier: string, input: string, data: NormalizedCountry[]): string => {
   if (identifier === 'sellingCountries') {
      return data.find((country: NormalizedCountry) => country.isoCode === input)?.name ?? input;
   }

   return input;
};

export const toFacetGroup = (facetResponse: FacetResponse, language: string, countries: NormalizedCountry[]): FacetGroup => ({
   identifier: facetResponse.identifier,
   facets: facetResponse.facets.map((facetContent) => ({
      name: facetContent.name,
      label: getTranslatableKey(facetResponse.identifier.key, facetContent.name, countries),
      range: facetContent.range,
      quantity: facetContent.quantity,
      nestedFacets: facetContent.nestedFacets?.map((nestedFacetGroup) => toFacetGroup(nestedFacetGroup, language, countries))
   }))
});
